import React, {useState, useEffect} from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Container, Card, Button, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { exportDayBookExcel } from "./ExportDayBookExcel";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//import { exportDayBookPDF } from "./ExportToPDF";

/*
 npm install file-saver
*/
const DayBook = () => {

  const today = new Date().toISOString().split("T")[0];

  const [ddlSectionId, setDdlSectionId] = useState();
  const [paramFromDate, setParamFromDate] = useState(today);
  const [paramToDate, setParamToDate] = useState(today);

  const [schoolName, setSchoolName] = useState();

  const [dayBookData, setDayBookData] = useState([]);
  const [ddlSections, setDdlSections] = useState([]);
  

  // Pagination states
  // const [currentPage, setCurrentPage] = useState(1);
  // const recordsPerPage = 10;

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const [ SectionRes] =
          await Promise.all([
            axios.get(`${BASE_URL}/api/ddl_sections`),
          ]);

        setDdlSections(SectionRes.data);

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }

    };

    fetchDropdowns();
  }, []);

  const handleRunReport = async () => {

    try {

      if (!ddlSectionId || ddlSectionId === '') {
        toast.error('Please select Section.');
        return;
      } else if (!paramFromDate || paramFromDate === '') {
        toast.error('Please enter From Date.');
        return;
      } else if (!paramToDate || paramToDate === '') {
        toast.error('Please enter To Date.');
        return;
      } else if (paramFromDate > paramToDate) {
        toast.error('From Date cannot be grater than To Date.');
        return;
      }

      const dayBookRes = await axios.get(`${BASE_URL}/api/rpt_day_book`,
        { params: { p_Section_Id: ddlSectionId, p_FromDate: paramFromDate, p_ToDate: paramToDate } });

      if (dayBookRes.data.length > 0) {
        setDayBookData(dayBookRes.data);
        setSchoolName(dayBookRes.data[0].school_name);
      } else {
        setDayBookData([]);
        toast.error('No Record available');
      }

    } catch (error) {
     toast.error('Error Day Book : ', error);
   }
 
  };

// Group data by date
  const groupedData = dayBookData.reduce((acc, curr) => {
    if (!acc[curr.vchr_date]) acc[curr.vchr_date] = [];
    acc[curr.vchr_date].push(curr);
    return acc;
  }, {});

  // Calculate grand totals
  const grandTotals = dayBookData.reduce(
    (totals, item) => {
      totals.dr += Number(item.dr_amt);
      totals.cr += Number(item.cr_amt);
      return totals;
    },
    { dr: 0, cr: 0 }
  );

  /// Export to Excel
  const exportToExcel = () => {

    exportDayBookExcel({
      dayBookData,
      fromDate: paramFromDate,
      toDate: paramToDate,
      schoolName: schoolName,
    });

  };

  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    const [year, month, day] = isoDate.split("-");
    return `${day}/${month}/${year}`;
  };

  /// download PDF
  const handleDownloadPDF = () => {

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "A4"
    });

    const reportTitle = `Day Book Report For the Period : ${formatDate(paramFromDate)} To ${formatDate(paramToDate)}`;

    // const reportDate = new Date().toLocaleDateString("en-IN", {
    //   year: "numeric",
    //   month: "long",
    //   day: "numeric",
    // });

    const reportDateTime = new Date().toLocaleString("en-IN", {
      year: "numeric",
      month: "short",   // or "long"
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
     // second: "2-digit",
      hour12: true,     // 12-hour format; set to false for 24-hour
    });

    // const pageWidth = doc.internal.pageSize.getWidth();
    // const centerX = pageWidth / 2;

    const headerHeight = 32; // reserve space for header
    const leftMargin = 14;
    const rightMargin = 14;

    // --- Draw header ---
    const drawHeader = () => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text(schoolName, doc.internal.pageSize.getWidth() / 2, 15, { align: "center" });

      doc.setFont("helvetica", "normal");
      doc.setFontSize(12);
      doc.text(reportTitle, doc.internal.pageSize.getWidth() / 2, 23, { align: "center" });

      // doc.setDrawColor(100); // grey line
      // doc.setLineWidth(0.3);
      // doc.line(14, 26, centerX, 26);
    };

    // --- Group data by date ---
    const groupedData = {};
    dayBookData.forEach((entry) => {
      if (!groupedData[entry.vchr_date]) groupedData[entry.vchr_date] = [];
      groupedData[entry.vchr_date].push(entry);
    });

    // --- Build table rows with subtotals ---
    const tableRows = [];
    let grandTotalDr = 0;
    let grandTotalCr = 0;

    Object.entries(groupedData).forEach(([date, entries]) => {
      let dateTotalDr = 0;
      let dateTotalCr = 0;

      entries.forEach((e) => {
        tableRows.push([
          date,
          e.vchr_no,
          e.cb_acct_name,
          e.narration,
          Number(e.dr_amt).toLocaleString("en-IN", { minimumFractionDigits: 2 }),
          Number(e.cr_amt).toLocaleString("en-IN", { minimumFractionDigits: 2 }),
        ]);
        dateTotalDr += Number(e.dr_amt);
        dateTotalCr += Number(e.cr_amt);
      });

      // Subtotal row for this date
      tableRows.push([
        { content: `Total for ${date}`, colSpan: 4, styles: { halign: "right", fontStyle: "bold", fillColor: [240, 240, 240] } },
        { content: dateTotalDr.toLocaleString("en-IN", { minimumFractionDigits: 2 }), styles: { halign: "right", fontStyle: "bold", fillColor: [240, 240, 240] } },
        { content: dateTotalCr.toLocaleString("en-IN", { minimumFractionDigits: 2 }), styles: { halign: "right", fontStyle: "bold", fillColor: [240, 240, 240] } },
      ]);

      grandTotalDr += dateTotalDr;
      grandTotalCr += dateTotalCr;
    });

    // --- Draw main table ---
    doc.autoTable({
      startY: headerHeight,
      margin: { top: headerHeight, left: leftMargin, right: rightMargin },
      head: [["Date", "Vchr No", "Account", "Narration", "Debit Amount", "Credit Amount"]],
      body: tableRows,
      theme: "grid",
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255, halign: "center" },
      columnStyles: {
        0: { halign: "center", cellWidth: 22 },
        1: { halign: "center", cellWidth: 25 },
        2: { cellWidth: 65 },
        3: { cellWidth: 95 },
        4: { halign: "right", cellWidth: 34 },
        5: { halign: "right", cellWidth: 34 },
      },
      didDrawPage: (data) => {
        // Redraw header on every page
        drawHeader();

        // Footer
        const pageWidth = doc.internal.pageSize.getWidth();
        const footerY = doc.internal.pageSize.getHeight() - 10;
        doc.setFontSize(9);
        doc.setDrawColor(150);
        doc.line(leftMargin, footerY - 3, pageWidth - rightMargin, footerY - 3);
        doc.text(`eSchool`, 20, footerY + 2, { align: "left" });
        doc.text(`Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`, pageWidth / 2, footerY + 2, { align: "center" });
        doc.text(`Generated on : ${reportDateTime}`, pageWidth - rightMargin, footerY + 2, { align: "right" });
      },
    });

    // --- Grand Total row ---
    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 3,
      margin: { left: leftMargin, right: rightMargin },
      body: [
        [
          { content: "Grand Total", colSpan: 4, styles: { halign: "right", fontStyle: "bold", fillColor: [200, 200, 200] } },
          { content: grandTotalDr.toLocaleString("en-IN", { minimumFractionDigits: 2 }), styles: { halign: "right", fontStyle: "bold", fillColor: [200, 200, 200] } },
          { content: grandTotalCr.toLocaleString("en-IN", { minimumFractionDigits: 2 }), styles: { halign: "right", fontStyle: "bold", fillColor: [200, 200, 200] } },
        ],
      ],
      theme: "plain",
      columnStyles: {
        0: { cellWidth: 25 },
        1: { cellWidth: 25 },
        2: { cellWidth: 65 },
        3: { cellWidth: 95 },
        4: { cellWidth: 35 },
        5: { cellWidth: 35 },
      },
    });

    doc.save(`DayBook_Report_Period-${formatDate(paramFromDate)}_To_${formatDate(paramToDate)} .pdf`);

  };

  return (
    <Container fluid className="p-3">
      {/* Header Section */}
      <Card className="mb-3 p-3">
        <Row className="mt-3">

          <Col md={3}>
            <InputGroup >
              <InputGroup.Text>Section</InputGroup.Text>
              <select className="form-select" name="ddlSectionId" value={ddlSectionId}
                onChange={(e) => setDdlSectionId(e.target.value)} >
                <option value="">-- Select Section --</option>
                {ddlSections.map(sec => (
                  <option key={sec.section_id} value={sec.section_id}>{sec.section_desc}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup >
              <InputGroup.Text style={{width: "120px"}}>From/To Date</InputGroup.Text>
            <input
              type="date" style={{textAlign: 'right'}}
              className="form-control"
              value={paramFromDate}
              onChange={(e) => setParamFromDate(e.target.value)}
            />
            <input
              type="date" style={{textAlign: 'right'}}
              className="form-control"
              value={paramToDate}
              onChange={(e) => setParamToDate(e.target.value)}
            />
            </InputGroup>
          </Col>

          {/* <Col md={3}>
            <InputGroup >
              <InputGroup.Text>To Date</InputGroup.Text>
            <input
              type="date" style={{textAlign: 'right'}}
              className="form-control"
              value={paramToDate}
              onChange={(e) => setParamToDate(e.target.value)}
            />
            </InputGroup>
          </Col> */}
          <Col md={5} className="d-flex justify-content-end">
            <Button style={{height: '40px', width: '145px'}} className="me-2" variant="secondary" 
                    onClick={exportToExcel} disabled={dayBookData.length === 0}>Download Excel</Button>
            <Button style={{height: '40px', width: '135px'}} className="me-2" variant="warning" 
                    onClick={handleDownloadPDF} disabled={dayBookData.length === 0}>Download PDF</Button>
            <Button style={{height: '40px', width: '135px'}} className="me-2" variant="success" 
                    onClick={handleRunReport} >Run Report</Button>

          </Col>
        </Row>

        {/* <Row className="mt-3">
          <Col md={12} className="d-flex justify-content-end">
            <Button className="me-2" variant="success" onClick={handleRunReport} >Run Report</Button>
            <Button className="me-2" variant="warning" onClick={handleDownloadPDF} disabled={dayBookData.length === 0}>PDF File</Button>
          </Col>
        </Row> */}

      </Card>

      {/* Details Table */}
      <Card className="p-3">
        <div style={{ minHeight: '380px' }} className="table-responsive">
          <table style={{ maxHeight: '35px' }}  className="responsive-table scty-custom-table-rcpt hover-table-rcpt">
            <thead className="table-light">
              <tr>
                <th style={{ textAlign: 'center', width: '7%' }}>Date</th>
                <th style={{ textAlign: 'center', width: '7%' }}>Vchr No</th>
                <th style={{ textAlign: 'left', width: '22%' }}>Account</th>
                <th style={{ textAlign: 'left', width: '25%' }}>Narration</th>
                <th style={{ textAlign: 'right', width: '9%' }} className="text-end">Debit Amount</th>
                <th style={{ textAlign: 'right', width: '9%' }} className="text-end">Credit Amount</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(groupedData).length > 0 ? (
                Object.entries(groupedData).map(([date, entries]) => {
                  const totalDr = entries.reduce((sum, e) => sum + Number(e.dr_amt), 0);
                  const totalCr = entries.reduce((sum, e) => sum + Number(e.cr_amt), 0);

                  return (
                    <React.Fragment key={date}>
                      {entries.map((dbook, idx) => (
                        <tr key={dbook.vchr_no + idx}>
                          <td style={{ textAlign: 'center' }}>{idx === 0 ? dbook.vchr_date : ''}</td>
                          <td style={{ textAlign: 'center' }}>{dbook.vchr_no}</td>
                          <td style={{ textAlign: 'left' }}>{dbook.cb_acct_name}</td>
                          <td style={{ textAlign: 'left' }}>{dbook.narration}</td>
                          <td className="text-end">{Number(dbook.dr_amt).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                          <td className="text-end">{Number(dbook.cr_amt).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                        </tr>
                      ))}

                      {/* Date total row */}
                      <tr style={{ fontWeight: 'bold', backgroundColor: '#f3f3f3' }}>
                        <td colSpan="4" className="text-end">Total For {date}:</td>
                        <td className="text-end">{totalDr.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                        <td className="text-end">{totalCr.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                      </tr>
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">No Data found.</td>
                </tr>
              )}

              {/* Grand Total */}
              {dayBookData.length > 0 && (
                <tr style={{ fontWeight: 'bold', backgroundColor: '#dcdcdc' }}>
                  <td colSpan="4" className="text-end">GRAND TOTAL:</td>
                  <td className="text-end">{grandTotals.dr.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                  <td className="text-end">{grandTotals.cr.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </Card>
    </Container>
  );
};

export default DayBook;
